

































































import {Component, Vue} from 'vue-property-decorator';
import {httpClient} from '@/api/baseApi';
import Loading from '@c/controls/Loading.vue';

/*
    Элемент журнала ошибок (/api/logs/error). Поля приходят из массива fields ответа;
    ожидаемо: [timestamp, uuid, module_type, level, code, message].
    message — обычный текст (в отличие от logs/common, где message — JSON-строка).
    Заголовки формируются динамически из fields, чтобы не сломаться при смене состава.
*/
interface ErrorItem {
  [key: string]: any;
}

@Component({components: {Loading}})
export default class LogsError extends Vue {
  items: ErrorItem[] = [];
  headers: any[] = [];
  loading = true;
  error = false;
  page = 1;
  itemsPerPage = 10;

  filterStartDate = '';
  filterEndDate = '';
  filterMinLevel: number | '' = '';
  filterModuleType = '';
  filterEventType = '';

  moduleOptions: {text: string; value: string}[] = [{text: 'Все', value: ''}];

  eventOptions = [
    {text: 'Все', value: ''},
    {text: 'Только границы', value: 'boundary_passed'},
    {text: 'Только устройства', value: 'device_changed'},
    {text: 'Только ошибки', value: 'error_occurred'},
  ];

  levelOptions = [
    {text: 'Все', value: ''},
    {text: '1 и выше', value: 1},
    {text: '2 и выше', value: 2},
    {text: '3 и выше', value: 3},
  ];

  async created() {
    this.loadModuleTypes();
    this.fetch();
  }

  async loadModuleTypes() {
    try {
      const {data} = await httpClient.get<[]>('module_types/');
      const opts = data.map((x: any) => ({text: x.description, value: x.value}));
      this.moduleOptions = [{text: 'Все', value: ''}].concat(opts);
    } catch {
      //Не критично: фильтр по модулю просто останется с опцией «Все».
    }
  }

  buildParams() {
    //Клиентская пагинация: грузим весь набор (лимит 1000), листает v-data-table.
    //Сервер не возвращает total — серверная пагинация невозможна.
    const params: any = {limit: 1000};
    if (this.filterStartDate) {
      params.start_date = new Date(this.filterStartDate).getTime();
    }
    if (this.filterEndDate) {
      params.end_date = new Date(this.filterEndDate).getTime() + 24 * 60 * 60 * 1000 - 1;
    }
    if (this.filterMinLevel !== '') {
      params.min_level = this.filterMinLevel;
    }
    if (this.filterModuleType) {
      params.module_type = this.filterModuleType;
    }
    if (this.filterEventType) {
      params.event_type = this.filterEventType;
    }
    return params;
  }

  headerTitle(name: string): string {
    const map: {[k: string]: string} = {
      timestamp: 'Время',
      uuid: 'UUID',
      module_type: 'Модуль',
      level: 'Уровень',
      code: 'Код',
      message: 'Сообщение',
      event_name: 'Событие',
    };
    return map[name] || name;
  }

  async fetch() {
    this.loading = true;
    this.error = false;
    try {
      const {data} = await httpClient.get('/logs/error', {params: this.buildParams()});
      const [rows, fields] = data;
      const names = (fields || []).map((f: any) => f[0]);
      this.headers = names.map((name: string) => {
        if (name === 'level') {
          return {text: this.headerTitle(name), value: name, width: '90px'};
        }
        if (name === 'message') {
          return {text: this.headerTitle(name), value: name};
        }
        return {text: this.headerTitle(name), value: name};
      });
      this.items = (rows || []).map((row: any) => {
        const item: ErrorItem = {};
        names.forEach((name: string, i: number) => {
          item[name] = row[i];
        });
        return item;
      });
      this.page = 1;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      this.error = true;
    }
  }

  applyFilters() {
    this.page = 1;
    this.fetch();
  }

  resetFilters() {
    this.filterStartDate = '';
    this.filterEndDate = '';
    this.filterMinLevel = '';
    this.filterModuleType = '';
    this.filterEventType = '';
    this.page = 1;
    this.fetch();
  }

  formatTs(ts: number | undefined | null): string {
    if (!ts) return '';
    const ms = ts < 1e12 ? ts * 1000 : ts;
    return new Date(ms).toLocaleString('ru-RU');
  }

  getLevelColor(level: any): string {
    if (level == 0) return 'green';
    else if (level == 1) return 'yellow';
    else if (level == 2) return 'orange';
    else if (level == 3) return 'red';
    else return '#ccc';
  }
}
